"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidatorModal = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _vuePropertyDecorator = require("vue-property-decorator");

var _vueJsonView = require("vue-json-view");

var _http = require("../utils/http");

var _dec, _dec2, _class, _class2, _descriptor, _descriptor2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var validatorTypes = [{
  title: '手机号',
  name: 'isPhone',
  type: 'checkbox'
}, {
  title: '邮箱',
  name: 'isEmail',
  type: 'checkbox'
}, {
  title: '最小值',
  name: 'min',
  type: 'input'
}, {
  title: '最大值',
  name: 'max',
  type: 'input'
}, {
  title: '最小长度',
  name: 'minLen',
  type: 'input'
}, {
  title: '最大长度',
  name: 'maxLen',
  type: 'input'
}, {
  title: '正则',
  name: 'pattern',
  type: 'input'
}, {
  title: '公式',
  name: 'formula',
  type: 'input'
}, {
  title: '请求',
  name: 'http'
}];
var ValidatorModal = (_dec = (0, _vuePropertyDecorator.Model)('change'), _dec2 = (0, _vuePropertyDecorator.Prop)(), (0, _vuePropertyDecorator.Component)(_class = (_class2 = (_temp = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(ValidatorModal, _Vue);

  var _super = _createSuper(ValidatorModal);

  function ValidatorModal() {
    var _this;

    (0, _classCallCheck2.default)(this, ValidatorModal);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _initializerDefineProperty2.default)(_this, "value", _descriptor, (0, _assertThisInitialized2.default)(_this));
    (0, _initializerDefineProperty2.default)(_this, "rules", _descriptor2, (0, _assertThisInitialized2.default)(_this));
    _this.visible = false;
    _this.type = null;
    _this.val = '';
    _this.method = 'get';
    _this.message = '';
    _this.name = '';
    return _this;
  }

  (0, _createClass2.default)(ValidatorModal, [{
    key: "currentType",
    get: function get() {
      var _this2 = this;

      if (!this.type) {
        return;
      }

      return validatorTypes.find(function (v) {
        return v.name === _this2.type;
      });
    }
  }, {
    key: "showModal",
    value: function showModal() {
      this.visible = true;
      this.type = null;
      this.val = '';
      this.message = '';
      this.method = 'get';
      this.name = '';
    }
  }, {
    key: "onOk",
    value: function onOk() {
      var _this$value = this.value,
          value = _this$value === void 0 ? [] : _this$value,
          message = this.message,
          val = this.val,
          method = this.method,
          type = this.type,
          name = this.name;

      if (type) {
        var newRule = {
          type: type,
          message: message || undefined,
          value: val
        };

        if (type === 'formula') {
          newRule.validator = function (data, value) {
            return _vueJsonView.Utils.transText(value, data);
          };
        }

        if (type === 'http') {
          newRule.validator = function (data) {
            if (method === 'post') {
              return _http.http.post(val, (0, _defineProperty2.default)({}, name, data)).then(function (res) {
                return res.data;
              });
            }

            return _http.http.get(val, {
              params: (0, _defineProperty2.default)({}, name, data)
            }).then(function (res) {
              return res.data;
            });
          };
        }

        this.$emit('change', [].concat((0, _toConsumableArray2.default)(value), [newRule]));
      }

      this.visible = false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var h = arguments[0];
      var _this$value2 = this.value,
          value = _this$value2 === void 0 ? [] : _this$value2,
          currentType = this.currentType,
          showModal = this.showModal,
          onOk = this.onOk,
          rules = this.rules;
      var tags = value.map(function (tag, i) {
        var obj = validatorTypes.find(function (val) {
          return val.name === tag.type;
        });

        if (obj) {
          var onClose = function onClose() {
            var newValue = value.slice();
            newValue.splice(i, 1);

            _this3.$emit('change', newValue);
          };

          return h("a-tag", {
            "attrs": {
              "closable": true,
              "visible": true
            },
            "on": {
              "close": onClose
            },
            "style": "margin-bottom: 8px;"
          }, [obj.title, " ", tag.value]);
        }
      });
      return h("span", [tags, value.length < 5 && h("a-button", {
        "on": {
          "click": function click() {
            return showModal();
          }
        },
        "attrs": {
          "block": true
        }
      }, [h("a-icon", {
        "attrs": {
          "type": "plus"
        }
      }), "\u6DFB\u52A0\u6821\u9A8C\u89C4\u5219"]), h("a-modal", {
        "attrs": {
          "title": "添加校验规则"
        },
        "on": {
          "ok": onOk
        },
        "model": {
          value: _this3.visible,
          callback: function callback($$v) {
            _this3.visible = $$v;
          }
        }
      }, [h("mh-form", {
        "attrs": {
          "layout": "vertical"
        }
      }, [h("mh-form-item", {
        "attrs": {
          "label": "校验类型"
        }
      }, [h("a-select", {
        "style": "width: 100%;",
        "model": {
          value: _this3.type,
          callback: function callback($$v) {
            _this3.type = $$v;
          }
        }
      }, [validatorTypes.map(function (type) {
        return (!rules || rules.includes(type.name)) && h("a-select-option", {
          "key": type.name
        }, [type.title]);
      })])]), currentType && currentType.type === 'input' && h("mh-form-item", {
        "attrs": {
          "label": "校验值"
        }
      }, [h("a-input", {
        "model": {
          value: _this3.val,
          callback: function callback($$v) {
            _this3.val = $$v;
          }
        }
      })]), currentType && currentType.name === 'http' && h("mh-form-item", {
        "attrs": {
          "label": "请求地址"
        }
      }, [h("a-input", {
        "model": {
          value: _this3.val,
          callback: function callback($$v) {
            _this3.val = $$v;
          }
        }
      })]), currentType && currentType.name === 'http' && h("mh-form-item", {
        "attrs": {
          "label": "请求方法"
        }
      }, [h("a-select", {
        "model": {
          value: _this3.method,
          callback: function callback($$v) {
            _this3.method = $$v;
          }
        }
      }, [h("a-select-option", {
        "attrs": {
          "value": "get"
        }
      }, ["Get"]), h("a-select-option", {
        "attrs": {
          "value": "post"
        }
      }, ["Post"])])]), currentType && currentType.name === 'http' && h("mh-form-item", {
        "attrs": {
          "label": "参数名"
        }
      }, [h("a-input", {
        "model": {
          value: _this3.name,
          callback: function callback($$v) {
            _this3.name = $$v;
          }
        }
      })])])])]);
    }
  }]);
  return ValidatorModal;
}(_vuePropertyDecorator.Vue), _temp), (_descriptor = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "value", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2.default)(_class2.prototype, "rules", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class2)) || _class);
exports.ValidatorModal = ValidatorModal;